module.exports = __webpack_public_path__ + "img/1.693e2428.png";